import { Button, Result } from 'antd'
import './CheckConnection.style.less'
import { WifiOutlined } from '@ant-design/icons'
import { memo, useEffect, useState } from 'react'

function CheckConnection() {
  const [isOnline, setisOnline] = useState(true)

  useEffect(() => {
    if (!navigator.onLine) setisOnline(false)

    window.addEventListener('offline', () => {
      setisOnline(false)
    })

    window.addEventListener('online', () => {
      setisOnline(true)
    })
  }, [])

  if (isOnline) return <></>

  return (
    <div className="no-connection">
      <div className="no-connection-item">
        <Result
          icon={<WifiOutlined />}
          title="No Connection!"
          extra={
            <Button
              type="primary"
              onClick={() => {
                window.location.reload()
              }}
            >
              Reload
            </Button>
          }
        />
      </div>
    </div>
  )
}

export default memo(CheckConnection)
